import { useMediaQuery } from '@vueuse/core';
import { breakpoints } from '@/assets/js/variables.js';

export function useMobile() {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.md}px)`);
  return { isMobile };
}
